import './styles/index.css';

// 导出类型
export type {
  PdfRenderProps,
  Annotation,
  ToolsConfig
} from './core';

// 导出其他类型
export type { MDAnnotation, TableAnnotation } from './core/types';

export type { StaticFileReaderProps } from './adopters/StaticFileReader';
// export type { GientechStreamReaderProps } from './adopters/GientechStreamReader';
export { default as Fviewer } from './core/Fviewer';
export { default as StaticFileReader } from './adopters/StaticFileReader';
// export { default as GientechStreamReader } from './adopters/GientechStreamReader';

// 导出文件解析工具
export {
  parseFile,
  parsePdfFile,
  parseImageFile,
  parseTextFile,
  parseMarkdownFile,
  detectFileType,
  type ParseResult,
  type ParseOptions,
  type FileType
} from './core/utils/fileParser';



/**
 * 文档忽略输出
 */
// 使用 legacy build，确保 GlobalWorkerOptions 在各构建形态下稳定存在
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';

export const isPDFWorkerRegistered = (): boolean => {
  return !!(pdfjsLib as any)?.GlobalWorkerOptions?.workerSrc;
};

export const getPDFWorkerPath = (): string | undefined => {
  return (pdfjsLib as any)?.GlobalWorkerOptions?.workerSrc;
};
export const registerPDFWorker = (workerPath: string = '/worker/pdf.worker.min.js') => {
  try {
    const globalWorkerOptions = (pdfjsLib as any)?.GlobalWorkerOptions;
    if (!globalWorkerOptions) {
      console.error(
        'PDF Worker 注册失败：pdfjs GlobalWorkerOptions 不存在。请检查 pdfjs-dist 版本/构建入口是否正确。'
      );
      return;
    }
    if (globalWorkerOptions.workerSrc) {
      console.log('PDF Worker 已经注册:', globalWorkerOptions.workerSrc);
      return;
    }
    globalWorkerOptions.workerSrc = workerPath;
    console.log('PDF Worker 注册成功:', workerPath);
  } catch (error) {
    console.error('PDF Worker 注册失败:', error);
  }
};
